__turbopack_context__.v({
  "cancelButton": "Djbqma_cancelButton",
  "confirmation": "Djbqma_confirmation",
  "image": "Djbqma_image",
  "info": "Djbqma_info",
  "message": "Djbqma_message",
});
